<template>
  <v-toolbar dark="" app class="shadow-md" color="primary">
    <v-toolbar-side-icon :round="false" @click="toggleRNav" />
    <v-spacer />

    <v-menu
      offset-y
      width="200px"
      nudge-bottom="13"
      content-class="elevation-1"
    >
      <v-btn icon slot="activator" color="primary" class="ma-0 pa-0" flat>
        <span>{{ lang.text }}</span>
      </v-btn>
      <v-list>
        <v-list-tile
          :key="index"
          @click="changeLang(item)"
          v-for="(item, index) in langs"
        >
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-btn flat icon class="ma-0 pa-0" @click="$router.go(-1)">
      <v-icon
        small
        v-html="$vuetify.rtl ? 'arrow_forward_ios' : 'arrow_back_ios'"
      />
    </v-btn>

    <v-btn flat icon class="ma-0 pa-0" @click="$router.go(1)">
      <v-icon
        small
        v-html="$vuetify.rtl ? 'arrow_back_ios' : 'arrow_forward_ios'"
      />
    </v-btn>
    <v-btn flat icon @click="toggleLNav" :class="{ 'mr-3': $vuetify.rtl }">
      <v-icon>mdi-shield-account</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  props: ["rdrawer", "ldrawer"],

  data: () => ({
    langs: [{ text: "EN", value: "en", dir: "ltr" }]
  }),

  computed: {
    lang() {
      return this.$store.state.lang;
    }
  },

  methods: {
    toggleRNav() {
      this.$emit("update:rdrawer", !this.rdrawer);
    },
    toggleLNav() {
      this.$emit("update:ldrawer", !this.ldrawer);
    },

    changeLang(lang) {
      this.$i18n.locale = lang.value;
      this.$store.commit("setLang", lang);
      this.$validator.localize(lang.value);
      this.$vuetify.rtl = lang.dir == "rtl";
      this.$vuetify.lang.current = lang.value;
      localStorage.setItem("lang", JSON.stringify(lang));
    }
  }
};
</script>
